/* global jQuery */
import React, { PropTypes } from 'react'
import Waypoint from 'react-waypoint'
import { LoaderIcon } from './index'

export default class Lazyload extends React.Component {
  constructor() {
    super()
    this._handleLazyLoad = this._handleLazyLoad.bind(this)

    this.scrollableAncestor = typeof window !== 'undefined' && window,
    this.state = {
      shouldForceLazyload : false
    }
  }

  static propTypes = {
    page: PropTypes.number,
    updateMore: PropTypes.func.isRequired,
    hasMore: PropTypes.bool.isRequired,
    threshold: PropTypes.number,
    enableForceLazyload: PropTypes.bool,
    increment: PropTypes.number
  }

  componentWillReceiveProps(nextProps) {
    const { page : currentPage } = nextProps
    const { page : prevPage, increment } = this.props
    const isLoadingComplete = (increment > 0) ? currentPage > prevPage : currentPage < prevPage

    // update for the state
    let stateUpdate = {
      shouldForceLazyload : isLoadingComplete
    }

    /**
     * set `isLoading` false if previous lazyload request is complete
     * or current page is `1`
     */
    if (isLoadingComplete === true || currentPage === 1) {
      stateUpdate.isLoading = false
    }

    this.setState(stateUpdate)
  }

  componentDidUpdate() {
    const { enableForceLazyload } = this.props
    const { shouldForceLazyload, isLoading } = this.state

    if (enableForceLazyload && shouldForceLazyload && !isLoading) {
      this._forceTriggerLazyLoad()
    }
  }

  _forceTriggerLazyLoad() {
    const { hasMore, threshold } = this.props
    const { wayPoint = '' } = this.refs
    const $window = jQuery(window)
    const docViewCovered = $window.height() * (1+threshold) + $window.scrollTop()

    // if no further data present or not browser rendering
    if (!(hasMore && process.browser)) {
      return
    }

    /*
     * force trigger lazy load if
     * wayPoint is in trigger area even after update of previous request
     */
    if (jQuery(wayPoint) != undefined && jQuery(wayPoint).offset().top <= docViewCovered) {
      this._handleLazyLoad(true)
    }
  }

  _handleLazyLoad(isForceLazyload) {
    let { page, updateMore, increment } = this.props
    const { isLoading } = this.state
    let nextPage

    if (!page) {
      return
    }

    // no lazyload api request if previous request is in progress
    if (isLoading === true) {
      return
    }

    // next page
    nextPage = page + (increment ? increment : 1)

    this.setState({
      isLoading : true
    })

    // update the next page
    updateMore(nextPage, isForceLazyload)
  }

  render() {
    const { hasMore, threshold, enableLoader } = this.props
    const { isLoading } = this.state

    if (hasMore) {
      // render lazyload component if more content available
      return (
        <div>
          <div ref="wayPoint" style={{ clear:'both', width:0, height:0, visibility: 'hidden' }}>
            <Waypoint
              onEnter={this._handleLazyLoad}
              threshold={threshold}
              scrollableAncestor={this.scrollableAncestor}/>
          </div>
          { enableLoader && isLoading &&
            <LoaderIcon />
          }
        </div>
      )
    } else {
      // render empty if no content
      return <span style={{ display:'none' }}/>
    }
  }
}

Lazyload.defaultProps = {
  threshold: 0.3,
  enableForceLazyload : false
}



/** WEBPACK FOOTER **
 ** ../app/components/common/Lazyload.jsx
 **/